import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const searchListCheck = (payload, userName) => {
    return api.makeRequest({
        url: `/hub/searchListCheck?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const uploadListCheck = (payload, userName) => {
    return api.makeRequest({
        url: `/hub/uploadListCheck?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const checkHotline = (listCheckId, userName) => {
    return api.makeRequest({
        url: `/hub/checkHotline?userName=${userName}&listCheckId=${listCheckId}`,
        method: 'POST',
    })
}

export const getPhoneList = (type, listCheckId, userName) => {
    return api.makeRequest({
        url: `/hub/getPhoneList?userName=${userName}&listCheckId=${listCheckId}&type=${type}`,
        method: 'POST',
    })
}